import { render, staticRenderFns } from "./RipaJsonViewer.vue?vue&type=template&id=6b57f305"
import script from "./RipaJsonViewer.vue?vue&type=script&lang=js"
export * from "./RipaJsonViewer.vue?vue&type=script&lang=js"
import style0 from "./RipaJsonViewer.vue?vue&type=style&index=0&id=6b57f305&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports